
import Vue from 'vue'
import MaterialsQuotationTransformer from '@/transformers/purchase/materialsQuotation'
import moment from 'moment'

function paramsTransformer({ page, size, search, highway, 
                             dateTo, dateFrom }) {
  return  {
     page, size,
     folio: search ? search : undefined,
     highway: highway ? highway : undefined,
     from: dateFrom ? moment(dateFrom).format('YYYY/MM/DD') : undefined,
     to: dateTo ? moment(dateTo).format('YYYY/MM/DD') : undefined,
  }
}

export default (options) => 
	Vue.$http.get(`purchase/materialsquotation/`,
    { params: paramsTransformer(options) })
		.then(response =>
			MaterialsQuotationTransformer.fetchCollection(response.data))
  



// WEBPACK FOOTER //
// ./src/services/purchase/fetchQuotations.js